import {util} from '../../utils'

const mutations = {
  demo: {
    update: ''
  },
  biz: {
    sys: {
      setUserProps: '',
      setEventGroups: '',
      setEnvMetas: '',
      edit: '',
      setCurrentUser: '',
      setCurrentApp: '',
      delEvent: '',
      editEvent: '',
      switchGroup: '',
      addGroup: '',
      updateGroup: '',
      delGroup: ''
    }
  },
  dataview: {
    setIgnores: '',
    setConfig: '',
    addConfig: '',
    delConfig: ''
  },
  userGroup: {
    setList: ''
  },
  visualizer: {
    setEventList: '',
    addEvent: '',
    delEvent: '',
    cancel: ''
  },
  userInfo: {
    setRecentEvents: '',
    setUserProps: '',
    setSessionCounts: '',
    setSessions: ''
  }
}

util.initializeConstants(mutations, 'biz-mutation')
export default mutations
